import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TlkCardComponent } from '@itero/ui-toolkit-angular/card';
import { TlkListboxComponent, TlkListboxOptionComponent } from '@itero/ui-toolkit-angular/listbox';

import { ArtTreatmentListItem } from '../../models';
import { RxIntuitiveArtTreatmentViewlistItemComponent } from '../rx-intuitive-art-treatment-viewlist-item/rx-intuitive-art-treatment-viewlist-item.component';

@Component({
	selector: 'rx-intuitive-art-treatment-viewlist',
	templateUrl: './rx-intuitive-art-treatment-viewlist.component.html',
	styleUrls: ['./rx-intuitive-art-treatment-viewlist.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		CommonModule,
		ReactiveFormsModule,
		TlkCardComponent,
		TlkListboxComponent,
		TlkListboxOptionComponent,
		RxIntuitiveArtTreatmentViewlistItemComponent
	]
})
export class RxIntuitiveArtTreatmentViewlistComponent {
	readonly cardPadding = 16;
	readonly selectedListOptionControl = new FormControl<string[]>([]);

	@Input() items: readonly ArtTreatmentListItem[] = [];
	@Input() chartReadOnly = false;
	@Output() readonly resetRequested = new EventEmitter<number>();

	trackByItem(index: number, item: ArtTreatmentListItem): string {
		return item.toothId.toString();
	}

	onResetRequested(toothId: number): void {
		this.resetRequested.emit(toothId);
	}
}
